import React from 'react';
import PropTypes from 'prop-types';
import { DayPickerSingleDateController as ReactDayPickerSingleDateController } from 'react-dates';

import { PreviousMonthButton, NextMonthButton } from './CustomMonthNavigationButtons';
import AvailabilityTypes from '../AvailabilityTypes';
import {
    renderDayWithTypeContents,
    renderCalendarDayWithType
} from './DayContentComponents';

export default class DayPickerSingleDateController extends React.PureComponent {
    static propTypes = {
        /** Function that takes a moment as a parameter and returns 'available',
         * 'walkup', 'lottery', 'currentReservation', or 'blocked' */
        getDayType: PropTypes.func.isRequired,

        /** Function that takes a moment as a parameter and returns the content
         * of the tooltip */
        getTooltipContent: PropTypes.func,

        /** Config object for the key/legend to hide/show specific day types */
        legendItems: PropTypes.shape({
            available: PropTypes.bool,
            checkout: PropTypes.bool,
            availableNumber: PropTypes.bool,
            walkup: PropTypes.bool,
            lottery: PropTypes.bool,
            unavailable: PropTypes.bool,
            unavailableReserved: PropTypes.bool,
            unavailableCross: PropTypes.bool,
            unavailableBlank: PropTypes.bool,
            availableBridged: PropTypes.bool,
            firstComeFirstServed: PropTypes.bool
        })
    };

    static defaultProps = {
        legendItems: {
            available: true,
            lottery: true,
            walkup: false,
            firstComeFirstServed: true,
            unavailable: true
        }
    };

    renderCalendarInfo = () => (
        <div
            className="sarsa-calendar-info-key"
            aria-hidden="true">
            <AvailabilityTypes
                legendItems={{
                    available: true,
                    lottery: true,
                    walkup: true,
                    unavailable: true
                }} />
        </div>
    )

    render() {
        const { getDayType, getTooltipContent, legendItems, ...rest } = this.props;

        return (
            <ReactDayPickerSingleDateController
                {...rest}
                hideKeyboardShortcutsPanel
                noBorder
                renderDayContents={renderDayWithTypeContents(getDayType)}
                renderCalendarDay={renderCalendarDayWithType(getDayType, getTooltipContent)}
                renderCalendarInfo={this.renderCalendarInfo}
                calendarInfoPosition="bottom"
                navPrev={<PreviousMonthButton />}
                navNext={<NextMonthButton />} />
        );
    }
}